import React, { Component } from 'react'
import './InfoBulle.css'
var parse = require('html-react-parser')

class InfoBulle extends Component {
    constructor(props) {
        super(props)
        this.state = {
            displayInfo: false,
            positionXOfInfoBulle: 0,
            widthScreen: 0,
        }
        this.infoBulleImgRef = React.createRef()
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
        this.handleClickInfoBulle = this.handleClickInfoBulle.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({ widthScreen: window.innerWidth })
        let positionXOfInfoBulle =
            this.infoBulleImgRef.current.getBoundingClientRect().x
        this.setState({ positionXOfInfoBulle: positionXOfInfoBulle })
    }

    handleClickInfoBulle(e) {
        e.preventDefault()
        e.stopPropagation()

        this.setState((state) => ({
            displayInfo: !this.state.displayInfo,
        }))
    }

    render() {
        const style = {}
        // -80 to take account of 40 padding pixel left + right
        if (this.infoBulleImgRef.current) {
            if (this.state.widthScreen <= 660) {
                let offsetToUse = -(
                    this.infoBulleImgRef.current.getBoundingClientRect().x -
                    window.innerWidth * 0.07
                )
                style.left = offsetToUse + 'px'
            } else {
                let offsetToUse = -(
                    this.infoBulleImgRef.current.getBoundingClientRect().x -
                    (window.innerWidth - 554) / 2
                )
                style.left = offsetToUse + 'px'
            }
        }

        let icone = 'svg/questions.svg'
        if (this.state.displayInfo) {
            style.display = ''
            icone = 'svg/questions-close.svg'
        } else {
            style.display = 'none'
        }

        return (
            <div className="InfoBulle">
                <img
                    src={icone}
                    className="infobulle"
                    alt="infobulle"
                    ref={this.infoBulleImgRef}
                    onClick={(e) => this.handleClickInfoBulle(e)}
                />
                <div className="OpenedInfoBulle" style={style}>
                    {' '}
                    {parse(this.props.text)}{' '}
                </div>
            </div>
        )
    }
}

export default InfoBulle
